import { cx } from "class-variance-authority";
import { Telescope, MessageCircleQuestion } from "lucide-react";
import React from "react";

export default function NotFound({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex flex-col items-center text-lg text-muted-foreground">
      <NotFoundIcon className="mb-4 text-muted-foreground" size={96} />
      <div className="text-foreground">Page not found (404)</div>
      <div>&nbsp;</div>
      <div>{children}</div>
    </div>
  );
}

export function NotFoundIcon({ className, size=96 }: { className?: string, size?: number }) {
  return (
    <div className={cx(`flex items-start`, className)}>
      <Telescope size={size} strokeWidth={1.25} />
      <MessageCircleQuestion className="relative -translate-y-[50%]" strokeWidth={2.5} size={size / 2} />
    </div>
  );
}
